// ABOUTME: Typed integration path keys for admin field registry scoping.
import { Destination, Source } from './enums';

export interface IntegrationPath {
  origin: Source;
  destination: Destination;
}

export function integrationPath(
  origin: Source,
  destination: Destination,
): IntegrationPath {
  return { origin, destination };
}

export function formatIntegrationPath(path: IntegrationPath): string {
  return `${path.origin} → ${path.destination}`;
}

export function matchesIntegrationPath(
  path: IntegrationPath,
  other: IntegrationPath,
): boolean {
  return path.origin === other.origin && path.destination === other.destination;
}

const SOURCE_VALUES = new Set<string>(Object.values(Source));
const DESTINATION_VALUES = new Set<string>(Object.values(Destination));

export function parseIntegrationPath(
  origin: string,
  destination: string,
): IntegrationPath {
  if (!SOURCE_VALUES.has(origin) || !DESTINATION_VALUES.has(destination)) {
    throw new Error(`Invalid integration path: ${origin} → ${destination}`);
  }

  return {
    origin: origin as Source,
    destination: destination as Destination,
  };
}

export function parseSource(origin: string): Source {
  if (!SOURCE_VALUES.has(origin)) {
    throw new Error(`Invalid polling origin: ${origin}`);
  }

  return origin as Source;
}

/** Polling items are keyed by origin; destination on the path is ignored. */
export function matchesPollingOrigin(
  path: IntegrationPath,
  origin: Source,
): boolean {
  return path.origin === origin;
}
